'use client'

import { Button, Image } from '@vinted/web-ui'

import { ShowAtBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import {
  landingPageEvent,
  InfluencerImageModel,
  InfluencerIntroductionModel,
  InfluencerLandingPageEvent,
} from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'
import { getFingerprint } from '@marketplace-web/session-management/audit-util'

type Props = {
  data: InfluencerIntroductionModel
}

export const IntroductionSection = ({
  data: { title, description, ctaText, ctaUrl, imageMobile, imageWeb, imageWide },
}: Props) => {
  const { track } = useTracking()

  const handleOnCtaClick = async () =>
    track(
      landingPageEvent({
        event: InfluencerLandingPageEvent.FollowClosetCtaClick,
        targetDetails: ctaUrl,
        deviceId: await getFingerprint(),
      }),
    )

  const renderHeroImage = (image: InfluencerImageModel) => (
    <div className="influencer__introduction-image">
      <Image
        src={image.x2Url}
        scaling="cover"
        testId="introduction-section-image"
        srcset={`${image.x1Url} 1x, ${image.x2Url} 2x, ${image.x3Url} 3x`}
      />
    </div>
  )

  return (
    <section className="influencer_introduction-section" data-testid="introduction-section">
      <h1 className="influencer__introduction-title">{title}</h1>
      <p className="influencer__introduction-description">{description}</p>
      <div className="influencer__introduction-cta">
        <Button
          styling="filled"
          text={ctaText}
          url={ctaUrl}
          onClick={handleOnCtaClick}
          testId="influencer__introduction-cta"
        />
      </div>
      <ShowAtBreakpoint breakpoint="phones">{renderHeroImage(imageMobile)}</ShowAtBreakpoint>
      <ShowAtBreakpoint breakpoint="tablets">{renderHeroImage(imageWeb)}</ShowAtBreakpoint>
      <ShowAtBreakpoint breakpoint="desktops">{renderHeroImage(imageWide)}</ShowAtBreakpoint>
    </section>
  )
}
